(() => {
 const normalize = value => value.toLocaleLowerCase('tr').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ı/g, 'i');
 function init(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const input = root.querySelector('[data-faq-search]');
  const items = [...root.querySelectorAll('[data-faq-item]')];
  const count = root.querySelector('[data-faq-count]');
  function update() {
   const query = normalize(input.value.trim());
   let visible = 0;
   items.forEach(item => { item.hidden = !normalize(item.textContent).includes(query); if (!item.hidden) visible++; });
   root.querySelectorAll('[data-faq-group]').forEach(group => { group.hidden = ![...group.querySelectorAll('[data-faq-item]')].some(item => !item.hidden); });
   root.querySelector('[data-faq-empty]').hidden = visible > 0;
   count.textContent = query ? `${visible} soru bulundu` : `${items.length} soruda Vitogon`;
  }
  input.addEventListener('input', update); update();
 }
 document.querySelectorAll('[data-faq-hub]').forEach(init);
 document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-faq-hub]').forEach(init));
})();
